import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeEditIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode_edit"}/>
}
